import { Component } from '@angular/core';
import { FeedbackPlatformReviewResponseEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'Review Responses') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-feedbackplatformreviewresponse-form',
    templateUrl: './feedbackplatformreviewresponse.form.component.html'
})
export class FeedbackPlatformReviewResponseFormComponent extends BaseFormComponent {
    public record!: FeedbackPlatformReviewResponseEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

